{{!-- TEACHER ITY OR DTY MESSAGE --}}
{{#if original.thankYouAssets}}
    {{#compare original.sourceId "==" 8}}
        <li id="pm{{original.id}}">
            <a name="ity"></a>
            <span class="activity-timestamp">{{original.createDatePhrase}}</span>
            <div class="activity-item">
                <div class="fluid-container">
                    <div class="col col8">
                        <div class="action">
                            <span class="user-avatar" style="background-image:url({{original.author.photoURL}})"></span>
                            <div class="activity-description">
                                <a href="{{userPageURL original.author}}">{{original.author.teacherScreenName}}</a>
                                posted an update
                            </div>
                        </div>
                        <div class="comment teacher-comment js-teacher-message">
                            <p>
                                {{{original.thankYouAssets.interimThankYouLetterText}}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    {{/compare}}
    {{#compare original.sourceId "==" 16}}
        {{#if original.thankYouAssets.mediumPhotoNames}}
            <li id="pm{{original.id}}">
                <a name="photos"></a>
                <span class="activity-timestamp">{{original.createDatePhrase}}</span>
                <div class="activity-item">
                    <div class="fluid-container">
                        <div class="col col8">
                            <div class="action">
                                <span class="user-avatar" style="background-image:url({{original.author.photoURL}})"></span>
                                <div class="activity-description">
                                    <a href="{{userPageURL original.author}}">{{original.author.teacherScreenName}}</a>
                                    shared photos
                                </div>
                            </div>
                            <div class="comment teacher-comment js-teacher-message">
                                {{#each original.thankYouAssets.mediumPhotoNames}}
                                    <div class="impact-photo" id="photoIndex{{@index}}" style="background-image: url({{this}})">
                                        <img src="{{this}}" />
                                    </div>
                                {{/each}}
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        {{/if}}
    {{/compare}}
    {{#compare original.sourceId "==" 32}}
        <li id="pm{{original.id}}">
            <a name="dty"></a>
            <span class="activity-timestamp">{{original.createDatePhrase}}</span>
            <div class="activity-item">
                <div class="fluid-container">
                    <div class="col col8">
                        <div class="action">
                            <span class="user-avatar" style="background-image:url({{original.author.photoURL}})"></span>
                            <div class="activity-description">
                                <a href="{{userPageURL original.author}}">{{original.author.teacherScreenName}}</a>
                                posted an update
                            </div>
                        </div>
                        <div class="comment teacher-comment js-teacher-message">
                            <p>
                                {{{original.thankYouAssets.impactLetterText}}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    {{/compare}}
{{/if}}
{{!-- END TEACHER ITY OR DTY MESSAGE --}}

{{!-- ONE OFF TEACHER MESSAGE --}}
{{#showOneOffTeacherComment original.sourceId}}
    <li id="pm{{original.id}}">
        <span class="activity-timestamp">{{original.createDatePhrase}}</span>
        <div class="activity-item">
            <div class="fluid-container">
                <div class="col col8">
                    <div class="action">
                        <span class="user-avatar" style="background-image:url({{original.author.photoURL}})"></span>
                        <div class="activity-description">
                            {{#if isStudentLed}}
                                <a href="{{userPageURL original.author}}">{{original.author.teacherScreenName}}</a> and {{teacherPossessivePronoun}}
                                {{#if moreThanOneStudent}}
                                    students
                                {{else}}
                                    student
                                {{/if}}
                            {{else}}
                                <a href="{{userPageURL original.author}}">{{original.author.teacherScreenName}}</a>
                            {{/if}}
                            {{#compare original.sourceId "==" 4096}}
                                submitted this project
                            {{else}}
                                responded
                            {{/compare}}
                        </div>
                    </div>
                    {{#compare original.sourceId "==" 4}}
                        <div class="comment teacher-comment js-teacher-message">
                            {{original.message}}
                        </div>
                    {{/compare}}
                </div>
            </div>
        </div>
    </li>
{{/showOneOffTeacherComment}}

{{!-- STAFF MESSAGE --}}
{{#compare original.sourceId "<" 4096}}
    {{#compare original.sourceId ">=" 128}}
    {{!-- fully funded message --}}
        {{#compare original.sourceId "==" 512}}
            <li id="pm{{original.id}}">
                <span class="activity-timestamp">{{original.createDatePhrase}}</span>
                <div class="activity-item">
                    <div class="action">
                        <span class="user-avatar" style="background-image:url({{baseCacheURL}}images/project/dc-activity-icon.png)"></span>
                        <div class="activity-description">
                            {{{original.message}}}
                        </div>
                    </div>
                </div>
            </li>
        {{else}}
            <li id="pm{{original.id}}">
                <span class="activity-timestamp">{{original.createDatePhrase}}</span>
                <div class="activity-item">
                    <div class="action">
                        <span class="user-avatar" style="background-image:url({{baseCacheURL}}images/project/dc-activity-icon.png)"></span>
                        <div class="activity-description">
                            <strong>{{original.author.firstName}}</strong>, {{original.author.type}}, {{{original.message}}}
                        </div>
                    </div>
                </div>
            </li>
        {{/compare}}
    {{/compare}}
{{/compare}}
{{!-- END STAFF MESSAGE --}}

{{!-- Default Donation message added after approval, only viewable to the teacher themselves --}}
{{#compare original.sourceId "==" 8192}}
    {{#compare userId "==" original.author.id}}
        <li id="pm{{original.id}}">
            <a name="dty"></a>
            <span class="activity-timestamp">{{original.createDatePhrase}}</span>
            <div class="activity-item">
                <div class="fluid-container">
                    <div class="col col8">
                        <div class="action">
                            <span class="user-avatar" style="background-image:url({{original.author.photoURL}})"></span>
                            <div class="activity-description">
                                <a href="{{userPageURL original.author}}">{{original.author.teacherScreenName}}</a>
                            </div>
                        </div>
                        <div class="comment teacher-comment js-teacher-message">
					<span>
						<span class="ty-heads-up">
							<em><b>Only visible to you.</b> For every donation you receive, you can write a personal note to the donor if you wish.
							Otherwise, we'll send them this message of thanks.</em>
						</span>
                        {{{original.message}}}
					</span>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    {{/compare}}
{{/compare}}

{{!-- DONATION MESSAGE OR donor comments --}}
{{#compare original.sourceId "<=" 2}}
    <li id="pm{{original.id}}" data-original-author-salutation="{{original.author.salutation}}">
        {{!-- ORIGINAL--}}
        <span class="activity-timestamp">{{original.createDatePhrase}}</span>
        <div class="activity-item">
            <div class="fluid-container">
                <div class="col col8">
                    <div class="action">
                        {{{userAvatar original.author ''}}}
                        <div class="activity-description">
                            <p>
                                {{#if original.anonymous}}
                                    <strong>A donor</strong>
                                    {{#if original.author.state}}
                                        from {{original.author.state}}
                                    {{/if}}
                                {{else}}
                                    {{#if original.author.salutation}}
                                        <strong>{{original.author.salutation}}</strong>
                                        {{locationAndDonorTeacherRelationship original.author true original.sourceId}}
                                    {{else}}
                                        {{locationAndDonorTeacherRelationship original.author false undefined}}
                                    {{/if}}
                                {{/if}}
                                {{#compare original.sourceId "==" 1}}
                                    gave
                                {{/compare}}
                                {{#compare original.numDonations ">" 1}}
                                    {{original.numDonations}} times
                                {{/compare}}

                                {{#each honorees}}
                                    {{#if @first}}in honor of{{/if}}
                                    {{#compare ../honorees.length ">" 1}}
                                        {{#if @last}}and{{/if}}
                                    {{/compare}}
                                    {{this.familiarDonorGreeting}}{{!
							}}{{#if this.city}} from {{this.city}}, {{this.stateAbbreviated}}{{/if}}{{!
							}}{{#unless @last}}, {{/unless}}
                                {{/each}}

                                {{#each inMemoryOfs}}
                                    {{#if @first}}in memory of{{/if}}
                                    {{#compare ../inMemoryOfs.length ">" 1}}
                                        {{#if @last}}and{{/if}}
                                    {{/compare}}
                                    {{this}}{{#unless @last}}, {{/unless}}
                                {{/each}}

                                {{#if original.givingPage}}
                                    {{#compare original.givingPage.name "!=" ""}}
                                        {{#compare original.honoree "||" original.inMemoryOf}} and {{/compare}}
                                        in support of <a href="{{baseURL}}{{original.givingPage.challengeURL}}">{{original.givingPage.name}}</a>
                                    {{/compare}}
                                {{/if}}
                                {{#if original.multipleGiftCodesToAcknowledge}}
                                    with {{#if original.givingHeavierCreditToGCPurchasers}}gift cards{{else}}help{{/if}} from a few friends
                                {{/if}}
                                {{#showGiftCodeText original}}
                                    with {{#if original.givingHeavierCreditToGCPurchasers}}a gift card{{else}}help{{/if}} from {{#isGiftCodeAnonymous original.giftCode}}an anonymous donor{{else}}<strong>{{#if original.giftCode.purchaserFamiliarDonorGreeting}}{{original.giftCode.purchaserFamiliarDonorGreeting}}{{/if}}</strong>{{/isGiftCodeAnonymous}}
                                {{/showGiftCodeText}}
                            </p>
                        </div>
                    </div>
                    {{#if original.message}}
                        <div class="comment {{#if original.author.correspondsToGrantAccount}}partner-comment{{/if}}">
                            {{{original.message}}}
                            {{#if original.donorMessageLink}}
                                <br/></br>
                                <a href="{{{original.donorMessageLink}}}" rel="nofollow" target="_blank">Learn more.</a>
                            {{/if}}
                        </div>
                    {{/if}}
                </div>
                <div class="col col4">
                    {{#showGiftCodeSection original}}
                    {{! data-track is used by getFirstSponsorCampaign() in trackProjectPageStatus.js }}
                        <div class="partner-logo-wrapper" {{#if original.giftCode.sponsor}}data-track='{"type": "gift card logo", "sponsor": { "sponsor" : "{{removeNonAlphaNumericChars original.giftCode.sponsor}}", "campaign" : "giftcode" } }'{{/if}}>
                            {{#if original.author.correspondsToGrantAccount}}
                                <span class="logo-holder" style="background-image:url({{original.author.photoURL}})">{{original.author.salutation}}</span>
                            {{else}}
                                {{#if original.giftCode}}
                                    {{#if original.giftCode.purchaserGrantAccountLogo}}
                                        <div class="giftcard">
                                            <span class="logo-holder" style="background-image:url({{original.giftCode.purchaserGrantAccountLogo}});">{{original.giftCode.purchaserFamiliarDonorGreeting}}</span>
                                        </div>
                                    {{/if}}
                                {{/if}}
                            {{/if}}
                        </div>
                    {{/showGiftCodeSection}}
                </div>
            </div>

            {{!-- PROMOCODE --}}
            {{#each promocodes}}

                <div id="pm{{this.id}}" class="fluid-container activity-response">
                    <div class="col col8">
                        <div class="action">
                            {{{userAvatar this.author 'partner'}}}
                            <div class="activity-description">
                                <strong>{{this.author.salutation}}</strong> matched this donation
                            </div>
                        </div>
                        {{#if this.message}}
                            <div class="comment partner-comment">
                                {{{this.message}}}
                                {{#if this.donorMessageLink}}
                                    <br/></br>
                                    <a href="{{{this.donorMessageLink}}}" rel="nofollow" target="_blank">Learn more.</a>
                                {{/if}}
                            </div>
                        {{/if}}
                    </div>
                    <div class="col col4">
                        {{#photoURLExistsAndIsNotPlaceholder this.author.photoURL}}
                            <div class="partner-logo-wrapper match-wrapper" {{#if this.sponsor}}data-track='{"type": "promo code logo", "sponsor": { "sponsor" : "{{removeNonAlphaNumericChars this.sponsor}}", "campaign" : "promocode" } }'{{/if}}>
                                <span class="logo-holder" style="background-image:url({{this.author.photoURL}})">{{this.author.salutation}}</span>
                            </div>
                        {{/photoURLExistsAndIsNotPlaceholder}}
                    </div>

                </div>
            {{/each}}

            {{!-- AUTODONATIONMATCH --}}
            {{#each autodonationmatches}}

                <div id="pm{{this.id}}" class="fluid-container activity-response">
                    <div class="col col8">
                        <div class="action">
                            {{{userAvatar this.author 'partner'}}}
                            <div class="activity-description">
                                <strong>{{this.author.salutation}}</strong> matched this donation
                            </div>
                        </div>
                        {{#if this.message}}
                            <div class="comment partner-comment">
                                {{{this.message}}}
                                {{#if this.donorMessageLink}}
                                    <br/></br>
                                    <a href="{{{this.donorMessageLink}}}" rel="nofollow" target="_blank">Learn more.</a>
                                {{/if}}
                            </div>
                        {{/if}}
                    </div>
                    <div class="col col4">
                        {{#photoURLExistsAndIsNotPlaceholder this.author.photoURL}}
                            <div class="partner-logo-wrapper match-wrapper" {{#if this.sponsor}}data-track='{"type": "promo code logo", "sponsor": { "sponsor" : "{{removeNonAlphaNumericChars this.sponsor}}", "campaign" : "autodonationmatch" } }'{{/if}}>
                                <span class="logo-holder" style="background-image:url({{this.author.photoURL}})">{{this.author.salutation}}</span>
                            </div>
                        {{/photoURLExistsAndIsNotPlaceholder}}
                    </div>
                </div>
            {{/each}}

            {{!-- RESPONSE --}}
            {{!-- TEACHER'S RESPONSE TO A USER'S COMMENT--}}
            {{!-- This always follows after the user's activity-item, giftcard div, and matching donor--}}
            {{!-- Keep in sync with proposalMessageResponse.tmpl --}}
            {{#each responses}}
                {{#if this.isDDM}}
                {{!-- Only show to the donor--}}
                    {{#if ../../showDDM}}
                        <div class="activity-response teacher-response fluid-container">
                            <div class="col col8">
                                <div class="action">
                                    {{{userAvatar this.author}}}
                                    <div class="activity-description">
                                        <a href="{{userPageURL this.author}}">{{this.author.teacherScreenName}}</a> responded
                                    </div>
                                </div>
                                {{#if this.message}}
                                    <div class="comment">
                                        {{{this.message}}}
                                    </div>
                                {{/if}}
                            </div>
                        </div>
                    {{/if}}
                {{else}}
                    <div class="activity-response teacher-response fluid-container">
                        <div class="col col8">
                            <div class="action">
                                {{{userAvatar this.author}}}
                                <div class="activity-description">
                                    <a href="{{userPageURL this.author}}">{{this.author.teacherScreenName}}</a> responded
                                </div>
                            </div>
                            {{#if this.message}}
                                <div class="comment">
                                    {{{this.message}}}
                                </div>
                            {{/if}}
                        </div>
                    </div>
                {{/if}}
            {{/each}}
            {{#unless original.apiDonation}}
                {{#if isTeacher}}
                    {{#unless original.hasResponse}}
                        {{#if responses}}
                            <div class="defaultMessageSent"><svg class="icon icon-check"><use xlink:href="/images/icon/icon-junior.svg#icon-check"></use></svg> We sent your prewritten thank you to this donor.</div>
                        {{/if}}
                        <a class="reply-button button-secondary small js-reply-button" data-original-id="{{original.id}}" data-original-author-salutation="{{escapeQuotes original.author.salutation}}" id="reply-button-{{original.id}}">Write a personalized note</a>
                    {{/unless}}
                {{/if}}
            {{/unless}}
            {{!-- END TEACHER RESPONSE TO A USER COMMENT--}}
        </div>

    </li>
{{/compare}}
{{!-- END DONATION MESSAGE --}}

{{!-- DIGITAL GRATITUDE MESSAGE --}}
{{#compare original.sourceId "==" 16384}}
    <li id="pm{{original.id}}">
        <span class="activity-timestamp">{{original.createDatePhrase}}</span>
        <div class="activity-item">
            <div class="fluid-container">
                <div class="col col8">
                    {{#if original.digitalGratitude.showLoginMessage}}
                        <div class="action">
                            <span class="user-avatar" style="background-image:url({{original.author.photoURL}})"></span>
                            <div class="activity-description">
                                <a href="{{userPageURL original.author}}">{{original.author.teacherScreenName}}</a>
                                posted photos
                            </div>
                        </div>
                        <div class="dg-placeholder"><svg class="icon icon-picture"><use xlink:href="/images/icon/icon-junior.svg#icon-picture"></use></svg></div>
                        <div class="log-in-cta">If you gave to this project, you may <a href="{{original.digitalGratitude.loginUrl}}">log in</a> to see photos.</div>
                    {{else}}
                        <div class="action">
                            <span class="user-avatar" style="background-image:url({{original.author.photoURL}})"></span>
                            <div class="activity-description">
                                <a href="{{userPageURL original.author}}">{{original.author.teacherScreenName}}</a>
                                posted photos
                                <p>(click to enlarge)</p>
                            </div>
                        </div>
                        <div class="image-gallery">
                            {{#each original.digitalGratitude.photoUrls}}
                                <a id="dgThumbnailPhoto{{@index}}" class="dg-thumbnail" style="background-image: url({{thumbnailUrl}})"></a>
                                <div id="dgMainPhoto{{@index}}" class="dg-target">
                                    <div class='image-container' role='presentation'>
                                        <img src={{mainUrl}} alt="{{original.author.teacherScreenName}}'s classroom photo update"/>
                                        <a class='image-close'><svg class="icon icon-close"><use xlink:href="/images/icon/icon-junior.svg#icon-close"></use></svg></a>
                                    </div>
                                </div>
                            {{/each}}
                        </div>
                    {{/if}}
                </div>
            </div>
        </div>
    </li>
{{/compare}}
{{!-- END DIGITAL GRATITUDE MESSAGE --}}

